'use strict';

function UnitConversion() {
}

/**
 * Parses a given string into its value and unit
 * @param {string} str A string with a value and a unit
 * @return {Object<number, string>}	An object containing a separated value and unit
 */
UnitConversion.prototype.parseUnit = function(str) {
	if (typeof str !== 'string') {
		throw TypeError('ParseUnit expects a string, received a ' + typeof str + '.');
	}

	var out = {
		value: 0,
		unit: ''
	}

	out.value = parseFloat(str, 10);
	out.unit = str.match(/[\d.\-\+]*\s*(.*)/)[1] || '';

	return out;
}

/**
 * Processes a time string into milliseconds
 * @param  {string} timeString The given time value
 * @return {number}            The time converted to milliseconds
 */
UnitConversion.prototype.convertSecondsToMS = function(timeString) {
	var /** @type {number} */ time = parseUnit(timeString);

	if (time.unit === 's') {
		time.value *= 1000;
	}

	return time.value;
};

module.exports = UnitConversion;
